import styled from "styled-components";
const Container = styled.button`
  border-radius: 0.4em;
  background: ${(props) => (!props.selected ? "#EDEEEE" : "#f2a900")};
  color: ${(props) => (!props.selected ? "#8A8D8F" : "#000")};
  box-shadow: ${(props) =>
    !props.selected ? "" : "0px 8px 16px rgb(242 169 0 / 25%)"};
  border: none;
  margin-right: 0.5em;
  font-size: 1.25em;
  padding: 0.25em 0.5em;
`;

const Button = (props) => {
  return (
    <Container selected={props.selected} onClick={props.onClick}>
      {props.label}
    </Container>
  );
};

export default Button;
